/*
 * @Author: huangzq
 * @Date: 2020-04-07 15:44:24
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-06-12 10:41:46
 * @Desc: table里面的单选组件
*/
<template>
  <mk-radio
    v-model="radioCheckedValue"
    :label="scope.row._id"
    class="table-radio"
    v-on="$listeners"
  >
    <!-- 用来占位的span，不然就会显示label里面的值 -->
    <span />
  </mk-radio>
</template>

<script>
export default {
  name: 'TableRadio',
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    },
    // 表格单选框选中的值：仅在表格为单选时，才会用
    selectRadio: {
      type: [Array, String, Number],
      default: 0
    }

  },
  data () {
    return {
      value: ''
    }
  },
  computed: {
    // 单选框被选中的值-多选框不会用的
    radioCheckedValue: {
      get () {
        return this.selectRadio
      },
      set (val) {
        this.$emit('select', val)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.table-radio {
  display: block;
  text-align: center;

  & /deep/ .el-radio__label {
    padding-left: 0;
  }
}
</style>
